import dailyHydratingFaceCreamImage from '../../../../assets/img/buy-again/daily-hydrating-face-cream.png';
import soothingCleanserImage from '../../../../assets/img/buy-again/soothing-cleanser.png';
import vitaminCSerumImage from '../../../../assets/img/buy-again/vitamin-c-serum.png';
import type { OrderItem } from './service';

export const PLACEHOLDER_ORDER_ITEMS: OrderItem[] = [
  {
    catalogItemId: '',
    productName: 'Vitamin C Serum',
    formattedPrice: '$45.99',
    imageUrl: vitaminCSerumImage,
  },
  {
    catalogItemId: '',
    productName: 'Soothing Cleanser',
    formattedPrice: '$25.00',
    imageUrl: soothingCleanserImage,
  },
  {
    catalogItemId: '',
    productName: 'Daily Hydrating Face Cream',
    formattedPrice: '$55.69',
    imageUrl: dailyHydratingFaceCreamImage,
  },
];
